<template>
  <div class="demand-room">
    <div class="main">
      <!-- 左边导航 -->
      <div class="nav-bar">
        <NavBarList @selectOption='selectOption' />
      </div>

      <!-- 右边展示内容 -->
      <div class="main-view">
        <!-- 内容顶部类型导航 -->
        <div class="type-nav">
          <TypeNavBar :typeList='typeList' @selectRtype='selectRtype' />
        </div>

        <!-- 内容展示 -->
        <div class="content-list">
          <VideoList :videoList='videoList' />

          <!-- 页码 -->
          <div class="page-num">
            <PageNum @currentChange='currentChangePage' :pageSize='16' :pageTotal='pageTotal'
              :currentPage1.sync='currentPage' />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { cloudClassSearch } from "@/network/cloudRequest/api";

//左边导航
import NavBarList from "@/views/cloudClassCenter/components/common/NavBarList";
//顶部导航
import TypeNavBar from "@/views/cloudClassCenter/components/common/TypeNavBar";
//内容导航--------------------------------------------
import VideoList from "@/views/cloudClassCenter/components/common/VideoList";
//页码导航--------------------------------------------
import PageNum from "@/components/common/PageNum";

export default {
  name: "DemandRoom",
  components: {
    NavBarList,
    TypeNavBar,
    VideoList,
    PageNum
  },
  data() {
    return {
      //视频列表--------------------------------------------
      videoList: [],

      //筛选的条件
      fd: {},

      //内容类型导航--------------------------------------------
      typeList: [{ name: "默认" }, { name: "最新" }, { name: "人气" }],

      //当前页码--------------------------------------------
      currentPage: 1,
      //页码总数量
      pageTotal: 0,
      //展示内容
      amCloudResource: {}
    };
  },

  methods: {
    //侧边筛选数据
    selectOption(option) {
      for (const key in option) {
        if (option.hasOwnProperty(key)) {
          const element = option[key];
          this.$set(this.fd, key, element);
        }
      }
      this.getSelectResource(this.fd);
    },

    //rtype筛选
    selectRtype(option) {
      // this.$set(this.fd, "type", option);
      // this.getSelectResource(this.fd);
    },

    //页面筛选--------------------------------------------
    currentChangePage(page) {},

    //根据条件获取数据
    getSelectResource(fd, type) {
      if (type != "pageNum") {
        this.fd.pageNum = 1;
        this.currentPage = 1;
      }

      //默认筛选10个--------------------------------------------
      this.fd.pageSize = 16;
      //0=1+N课堂，1=直播，2=点播 空=全部(参数为空时默认查询1+n课堂)
      this.fd.type = 2;

      let page = {
        pageNum: fd.pageNum,
        pageSize: fd.pageSize
      };
      cloudClassSearch(page, fd).then(res => {
        if (res.data.success) {
          this.videoList = res.data.data ? res.data.data.list : [];
          this.pageTotal = res.data.data ? Number(res.data.data.total) : 0;
        }
      });
    }
  }
};
</script>

<style lang='less' scoped>
.demand-room {
  padding-top: 5px;

  .main {
    display: flex;

    margin: 0 auto;
    width: 1200px;
    min-height: 1200px;

    justify-content: space-between;

    // 左边导航
    .nav-bar {
      border-radius: 5px;
      padding: 0 20px;
      width: 235px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;
    }

    //内容
    .main-view {
      overflow: hidden;

      border-radius: 5px;
      width: 960px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;

      .content-list {
        height: 100%;

        .page-num {
          display: flex;

          margin: 20px 0;

          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>